module.exports = __webpack_public_path__ + "img/banner.1944cde3.png";